import type { TrackingPest } from 'src/api/domains/service-tracking/serviceTracking.types'

export enum TreatmentStatus {
  // Completed
  Covered = 'covered',
  Paid = 'paid',
  Approved = 'approved',
  // In Progress
  NeedsReview = 'needsReview',
  PropertyManagerReview = 'propertyManagerReview',
  QuoteAtTimeOfService = 'quoteAtTimeOfService',
  PaymentRequired = 'paymentRequired',
  // Excluded
  NotApproved = 'notApproved',
  NotCovered = 'notCovered',
  Declined = 'declined',
  Voided = 'voided',
  // Hidden
  Hidden = 'hidden',
}

export const TREATMENT_BUCKET = {
  IN_PROGRESS: 'inProgress',
  EXCLUDED: 'excluded',
  COMPLETED: 'completed',
} as const

export type TreatmentBucket = (typeof TREATMENT_BUCKET)[keyof typeof TREATMENT_BUCKET]

export type TreatmentEntryData = {
  bucket: TreatmentBucket
  pest: TrackingPest
  status: TreatmentStatus
}
